module.exports = __webpack_public_path__ + "static/img/underway.6f7046d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/underway.png
// module id = pgPz
// module chunks = 0